import { datetime, today } from "src/utils";

// BE day-index convention (0 = Monday ... 6 = Sunday), matching `days_week` on
// the wire.
export const DAY_LABEL: Record<string, string> = {
  "0": "จ",
  "1": "อ",
  "2": "พ",
  "3": "พฤ",
  "4": "ศ",
  "5": "ส",
  "6": "อา",
};

export type WebsiteSystemPeriod = {
  typeTime: string;
  daysWeek: string[];
  startDatetime?: string;
  endDatetime?: string;
};

export const formatWebsiteSystemPeriod = ({
  typeTime,
  daysWeek,
  startDatetime,
  endDatetime,
}: WebsiteSystemPeriod): string => {
  if (typeTime === "schedule") {
    const days = [...daysWeek]
      .sort()
      .map((day) => `${DAY_LABEL[day] || day}.`)
      .join(" ");
    // start/end are recurring wall-clock times, not a specific date. Derive
    // Bangkok-local HH:mm the same way useSystemStatus.ts does - via
    // start_datetime/end_datetime through today() - rather than the API's own
    // start_time/end_time strings, which are naive UTC and would be off by 7
    // hours if rendered directly.
    const start = startDatetime ? today(startDatetime).format("HH:mm") : "--:--";
    const end = endDatetime ? today(endDatetime).format("HH:mm") : "--:--";
    return `${days} ${start}–${end}`.trim();
  }
  if (typeTime === "custom") {
    const start = startDatetime ? datetime(startDatetime).format("DD/MM/YY HH:mm") : "-";
    const end = endDatetime ? datetime(endDatetime).format("DD/MM/YY HH:mm") : "-";
    return `${start} – ${end}`;
  }
  return "ทันที";
};
